import React, { createContext, useContext } from "react"

/**
 * Read-only context — wraps the bookings tree when the logged-in user is a
 * third-party auditor. Components inside the tree consult this to hide
 * write affordances. Server-side enforcement still lives in firestore.rules
 * (userIsAuditor never grants write); this context only governs UX.
 */
const ReadOnlyContext = createContext(false)

export const ReadOnlyProvider = ({ value, children }) => (
    <ReadOnlyContext.Provider value={value === true}>
        {children}
    </ReadOnlyContext.Provider>
)

export const useReadOnly = () => useContext(ReadOnlyContext)

export default ReadOnlyContext
